import React from "react";
import { BreadCrumbItem } from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import CardSection from "./CardSection";

const breadCrumbs: BreadCrumbItem[] = [
  {
    path: "/",
    label: "Inicio",
  },
  {
    path: "/ventas",
    label: "Ventas",
    isActive: true,
  },
];

function Ventas() {
  return (
    <Page
      title="Ventas y pagos"
      description="Gestión de ventas y pagos."
      breadCrumbs={breadCrumbs}
    >
      <CardSection />
    </Page>
  );
}

export default Ventas;